import { CMSResource } from "app/resources/cmsresource";
import { FooterCellResource } from "app/models/FooterCellResource";

export class FooterCellListResource extends CMSResource {
    
    footerCellListResource: FooterCellResource[];
        
}